import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { BaseAddressModel, BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface CheckoutShippingStateType {
    readonly condition: boolean;
    readonly billToData: BillToModel;
    readonly shipToData: ShipToModel;
    readonly defaultUseBilling: boolean;
}
export type CustomCheckoutShippingState = Readonly<CheckoutShippingStateType>;
export const initialCheckoutShippingState: CustomCheckoutShippingState = {
    condition: false,
    billToData: {} as BillToModel,
    shipToData: {} as ShipToModel,
    defaultUseBilling: true,
};
export const customCheckoutShippingReducer = createTypedReducer(initialCheckoutShippingState, {
    "Custom/CheckoutShippingState/Condition": (
        draft: Draft<CustomCheckoutShippingState>,
        { condition }: { condition: boolean },
    ) => ({
        ...draft,
        condition,
    }),
    "Custom/CheckoutShippingState/UpdateBillToData": (
        draft: Draft<CustomCheckoutShippingState>,
        { data }: { data: BaseAddressModel },
    ) => ({
        ...draft,
        billToData: {
            ...draft.billToData,
            ...data,
        },
    }),
    "Custom/CheckoutShippingState/UpdateShipToData": (
        draft: Draft<CustomCheckoutShippingState>,
        { data }: { data: BaseAddressModel },
    ) => ({
        ...draft,
        shipToData: {
            ...draft.shipToData,
            ...data,
        },
    }),
    "Custom/CheckoutShippingState/UpdateDefaultUseBilling": (
        draft: Draft<CustomCheckoutShippingState>,
        { defaultUseBilling }: { defaultUseBilling: boolean },
    ) => ({
        ...draft,
        defaultUseBilling,
    }),
});
